import { DOCUMENT_TYPE } from "@/pages-components/quotes/enums";

/** Document types whose ERP send flow has the FrontDesk branch. */
export const FRONTDESK_SEND_DOCUMENT_TYPES: readonly DOCUMENT_TYPE[] = [
  DOCUMENT_TYPE.quote,
  DOCUMENT_TYPE.order,
  DOCUMENT_TYPE.deliveryNote,
  DOCUMENT_TYPE.deliveryNoteRefund,
  DOCUMENT_TYPE.invoice,
  DOCUMENT_TYPE.invoiceRefund,
];

export const canSendDocumentViaFrontDesk = (
  documentType: DOCUMENT_TYPE | number | undefined,
  ticketId: string | null | undefined,
): boolean =>
  FRONTDESK_SEND_DOCUMENT_TYPES.includes(documentType as DOCUMENT_TYPE) &&
  typeof ticketId === "string" &&
  ticketId.trim().length > 0;

const ERROR_KEYS: Record<string, string> = {
  frontdesk_not_linked: "alerts.frontDeskSend.notLinked",
  frontdesk_no_usable_path: "alerts.frontDeskSend.noUsablePath",
  frontdesk_conversation_not_found: "alerts.frontDeskSend.conversationNotFound",
  frontdesk_conversation_expired: "alerts.frontDeskSend.conversationExpired",
  frontdesk_auto_send_conflict: "alerts.frontDeskSend.autoSendConflict",
  frontdesk_whatsapp_window_closed: "alerts.frontDeskSend.whatsAppWindowClosed",
  frontdesk_access_denied: "alerts.frontDeskSend.accessDenied",
  frontdesk_delivery_unknown: "alerts.frontDeskSend.deliveryUnknown",
  frontdesk_send_failed: "alerts.frontDeskSend.sendFailed",
};

type SendDocumentResult = {
  success?: boolean;
  status?: number;
  errors?: { message?: unknown } | null;
};

/**
 * Translation key for a failed Send → FrontDesk. No HTTP status means the
 * request got no answer (e.g. timed out), so the message may still have been
 * delivered.
 */
export const frontDeskSendErrorKey = (res: SendDocumentResult | null | undefined): string => {
  const code = res?.errors?.message;
  if (typeof code === "string" && ERROR_KEYS[code]) return ERROR_KEYS[code];
  if (!res?.status) return ERROR_KEYS.frontdesk_delivery_unknown;
  return ERROR_KEYS.frontdesk_send_failed;
};
